import React from 'react';
import { useTranslation } from 'react-i18next';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import Faqs from '../../components/Home/Faqs/Faqs.js';

const Faq = () => {
    const { t } = useTranslation();

    return (
        <main className="main">
            <Breadcrumb title={t('nav.faq')} />
            <Faqs />
        </main>
    );
};

export default Faq;
